import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider, useTheme } from "@/theme/ThemeContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/auth/AuthContext";
import { SiteProvider } from "@/site/SiteContext";
import { FavoritesProvider } from "@/favorites/FavoritesContext";
import { QuickViewProvider } from "@/components/QuickViewProvider";
import FavoritesUI from "@/components/FavoritesUI";
import Preloader from "@/components/Preloader";
import ScrollProgress from "@/components/ScrollProgress";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Catalog from "@/components/Catalog";
import BestSellers from "@/components/BestSellers";
import Portfolio from "@/components/Portfolio";
import WhyUs from "@/components/WhyUs";
import Reviews from "@/components/Reviews";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import AuthModal from "@/components/AuthModal";
import CookieConsent from "@/components/CookieConsent";
import AdminPage from "@/pages/AdminPage";
import LegalPage from "@/pages/LegalPage";

const Home = () => (
  <div className="App bg-background min-h-screen text-foreground antialiased overflow-x-hidden">
    <Preloader />
    <ScrollProgress />
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <Catalog />
      <BestSellers />
      <Process />
      <Portfolio />
      <WhyUs />
      <Reviews />
      <Faq />
      <Contact />
    </main>
    <Footer />
    <FloatingButtons />
    <AuthModal />
    <CookieConsent />
  </div>
);

const ThemedToaster = () => {
  const { theme } = useTheme();
  return (
    <Toaster
      position="bottom-center"
      theme={theme}
      toastOptions={{
        style: {
          background: "hsl(var(--card))",
          border: "1px solid rgba(212,175,55,0.3)",
          color: "hsl(var(--foreground))",
        },
      }}
    />
  );
};

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <SiteProvider>
            <FavoritesProvider>
              <QuickViewProvider>
                <FavoritesUI />
                <BrowserRouter>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/privacy" element={<LegalPage variant="privacy" />} />
                    <Route path="/mentions-legales" element={<LegalPage variant="legal" />} />
                  </Routes>
                  <ThemedToaster />
                </BrowserRouter>
              </QuickViewProvider>
            </FavoritesProvider>
          </SiteProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
